//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import UAParser from 'ua-parser-js';
import { Link } from "react-router-dom";

//Components
import Heading from '../components/CASA/Heading';
import CASASpinner from '../components/Portal/CASASpinner';
import SortedTable from '../components/Portal/SortedTable';
import MetaTags from 'react-meta-tags';
import AUbutton from '@gov.au/buttons';
import { AUcallout } from '@gov.au/callout';
import { AUformGroup } from '@gov.au/form';
import AUdirectionLink from '@gov.au/direction-links';
import CasaModal from '../components/CASA/CasaModal';

//Actions
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getSnippetSelector, getFeatureSelector, getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getDownloadFCLGoogleDetails, FETCH_DOWNLOADFCLGOOGLE_SUCCESS } from '../PortalStore/Actions/DownloadFCLGoogleActions';
import { getDownloadFCLAppleDetails, FETCH_DOWNLOADFCLAPPLE_SUCCESS } from '../PortalStore/Actions/DownloadFCLAppleActions';
import { getFlightCrewIndividualPicture, FETCH_FLIGHTCREWINDIVIDUALPICTURE_SUCCESS } from '../PortalStore/Actions/FlightCrewIndividualPictureActions';
import { getFlightCrewComponents, FETCH_FLIGHTCREWCOMPONENTS_SUCCESS } from '../PortalStore/Actions/FlightCrewComponentsActions';
import { getFlightCrewRatings, FETCH_FLIGHTCREWRATINGS_SUCCESS } from '../PortalStore/Actions/FlightCrewRatingsActions';
import { getFlightCrewOperationalRatings, FETCH_FLIGHTCREWOPERATIONALRATINGS_SUCCESS } from '../PortalStore/Actions/FlightCrewOperationalRatingsActions';
import { getFlightCrewTheoryExaminations, FETCH_FLIGHTCREWTHEORYEXAMINATIONS_SUCCESS } from '../PortalStore/Actions/FlightCrewTheoryExaminationsActions';
import { setInnerHTML } from '../components/Portal/Utilities';
import { FCL_CONSTANTS } from 'internalConstants';

export const PilotLicenceDetailsPage = () => {
    const [pilotLicenceDetailsLoaded, setPilotLicenceDetailsLoaded] = useState({ loaded: false, error: false });
    const [modalActiveGoogle, setModalActiveGoogle] = useState(false);
    const [modalActiveApple, setModalActiveApple] = useState(false);
    const [showSpinnerFlag, setShowSpinnerFlag] = useState(false);
    const [googleDownloadDone, setGoogleDownloadDone] = useState(false);
    const [appleDownloadDone, setAppleDownloadDone] = useState(false);
    const [iphone, setIphone] = useState(false);
    const [android, setAndroid] = useState(false);

    const user = useSelector(state => state.userdetails.items?.value[0]);

    let B2CSettings = useSelector(state => state.B2CSettings.items);

    let picture = useSelector(state => state.FlightCrewIndividualPicture.items);
    let hasPicture = picture === 'Picture found';
    let components = useSelector(state => state.FlightCrewComponents.items);
    let hasComponents = components.components?.length > 0;
    let ratings = useSelector(state => state.FlightCrewRatings.items);
    let operationalRatings = useSelector(state => state.FlightCrewOperationalRatings.items);
    let theoryExaminations = useSelector(state => state.FlightCrewTheoryExaminations.items);

    let urlAEMHome = useSelector(state => getUrlSelector(state, 'Portal - AEM URL'));
    let urlAEMLicenceReprint = useSelector(state => getUrlSelector(state, 'Portal - AEM Licence Reprint URL'));

    let digitalFCLFeature = moment(useSelector(state => getFeatureSelector(state, 'Portal - Feature Availability - Digital Flight Crew Licence')),'DD/MM/YYYY');
    let digitalFCLFeatureAvailable = digitalFCLFeature.isBefore();

    let googleSnippet = useSelector(state => getSnippetSelector(state, 'CASA - Download Google Licence FCL'));
    let appleSnippet = useSelector(state => getSnippetSelector(state, 'CASA - Download Apple Licence FCL'));
    const googleUrl = useSelector(state => state.DownloadFCLGoogle.items);
    const appleUrl = useSelector(state => state.DownloadFCLApple.items);

    const dispatch = useDispatch();

    var showItems = false;

    var items = [
        {
            link: '/dashind',
            text: 'myCASA'
        },
        {
            text: 'Flight crew licences'
        }
    ];
    showItems = true;

    const isMountedRef = useRef(true);

    useEffect(() => {

        dispatch(addPageAlert({ level: '', title: '', message: '' }));

        if (!pilotLicenceDetailsLoaded.loaded) {

            let parser = new UAParser();
            setIphone(parser.getDevice().model === 'iPhone' && parseFloat(parser.getOS().version) >= 8.0);
            setAndroid(parser.getOS().name === 'Android');

            axios.all([
                dispatch(getFlightCrewIndividualPicture(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal, user.casa_arn)),
                dispatch(getFlightCrewComponents(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal, user.casa_arn)),
                dispatch(getFlightCrewRatings(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal, user.casa_arn)),
                dispatch(getFlightCrewOperationalRatings(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal, user.casa_arn)),
                dispatch(getFlightCrewTheoryExaminations(B2CSettings.webappurlPortalApi, B2CSettings.accesstokenPortal, user.casa_arn))
            ])
                .then(axios.spread((picres, compres, ratres, operratres, examres) => {
                    if (isMountedRef.current) {
                        if (!(picres.type === FETCH_FLIGHTCREWINDIVIDUALPICTURE_SUCCESS
                            && compres.type === FETCH_FLIGHTCREWCOMPONENTS_SUCCESS
                            && ratres.type === FETCH_FLIGHTCREWRATINGS_SUCCESS
                            && operratres.type === FETCH_FLIGHTCREWOPERATIONALRATINGS_SUCCESS
                            && examres.type === FETCH_FLIGHTCREWTHEORYEXAMINATIONS_SUCCESS
                        )) {
                            dispatch(addPageAlert({ level: 'error', title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.', message: 'Details: System error (Code: PLD.1)' }));
                        }
                    }
                }))
                .catch(() => {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: PLD.2)'
                    }));
                })
                .finally(() => {
                    setPilotLicenceDetailsLoaded({ loaded: true, error: false });
                });               
        }

        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (googleDownloadDone) {
            window.location.href = googleUrl.saveGooglePassUri;
        }
    }, [googleDownloadDone]);

    useEffect(() => {

        if (appleDownloadDone) {
            let reader = new FileReader();
            let blob = new Blob([appleUrl], { type: 'application/vnd.apple.pkpass' });

            reader.onloadend = function () {
                reader.fileName = 'FCl_CASA_Licence.pkpass';
                window.location.href = reader.result;
            };

            reader.readAsDataURL(blob);
        }

    }, [appleDownloadDone]);

    const toggleModalGoogle = () => setModalActiveGoogle(!modalActiveGoogle);

    const toggleModalApple = () => setModalActiveApple(!modalActiveApple);

    const onDigLicGoogleClick = () => setModalActiveGoogle(true);

    const onDigLicAppleClick = () => setModalActiveApple(true);

    const getGoogleLicence = () => {
        setModalActiveGoogle(false);
        setShowSpinnerFlag(true);

        const webappurl = B2CSettings.DigitalLicenceAPIUrl;

        axios.all([
            dispatch(getDownloadFCLGoogleDetails(webappurl, B2CSettings.accesstokenPortal, user.casa_arn))
        ])
            .then(axios.spread((drres) => {
                if (drres.type === FETCH_DOWNLOADFCLGOOGLE_SUCCESS) {
                    setGoogleDownloadDone(true);
                }
                else {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: DRGL.1)'
                    }));
                }
            }))
            .catch(() => {
                dispatch(addPageAlert({
                    level: 'error',
                    title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                    message: 'Details: System error (Code: DRGL.2)'
                }));
            })
            .finally(() => {
                setShowSpinnerFlag(false);
            });
    };

    const getAppleLicence = () => {
        setModalActiveApple(false);
        setShowSpinnerFlag(true);

        const webappurl = B2CSettings.DigitalLicenceAPIUrl;

        axios.all([
            dispatch(getDownloadFCLAppleDetails(webappurl, B2CSettings.accesstokenPortal, user.casa_arn))
        ])
            .then(axios.spread((drres) => {
                if (drres.type === FETCH_DOWNLOADFCLAPPLE_SUCCESS) {
                    setAppleDownloadDone(true);
                }
                else {
                    dispatch(addPageAlert({
                        level: 'error',
                        title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                        message: 'Details: System error (Code: DRAL.1)'
                    }));
                }
            }))
            .catch(function () {
                dispatch(addPageAlert({
                    level: 'error',
                    title: 'We\'re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.',
                    message: 'Details: System error (Code: DRAL.2)'
                }));
            })
            .finally(() => {
                setShowSpinnerFlag(false);
            });
    };

    const showSpinner = () => {
        if (showSpinnerFlag) {
            return <CASASpinner message='Working. Please wait.....' />;
        }
    };

    const pastDate = (row, column) => {
        if (row.validto != 'N/A'
            && moment().toISOString() > moment(row.validto, 'DD MMM YYYY').toISOString()
            && column.property == 'validto') {
            return {
                fontWeight: 'lighter',
                fontStyle: 'italic'
            }
        }
    }

    const addBadge = (row, column) => {
        if (row["status"] != "Active" && column.property == "status") {
            return  "badge badge-expired";
        }
    };

    const navigateLicenceRePrint = () => {
        var url = urlAEMHome + urlAEMLicenceReprint;
        var crumbs = [
            {
                link: '/dashind',
                text: 'myCASA'
            },
            {
                link: '/licence-view-multiple',
                text: 'Flight crew licence'
            }
        ];
        var params = {
            'formID': 'LICENCE-VIEW-MULTIPLE',
            'breadcrumbs': crumbs
        };

        location.assign(url + '?params=' + encodeURIComponent(btoa(JSON.stringify(params))));
    };

    let sortOrderCategory = ['Aeroplane', 'Helicopter', 'Gyroplane', 'Airship', 'Powered Lift', 'Glider', 'Other'];

    const getCustomSortOrder = function (sortOrder){
        let ordering = {}; // map for efficient lookup of sortIndex
        for (let i=0; i<sortOrder.length; i++){
            ordering[sortOrder[i].toUpperCase()] = i;
        }
        return ordering;
    }

    const ignoreGliderFromSorting = function (a, b){
        return (a.category === 'Glider') - (b.category === 'Glider');
    }

    const orderByValidFrom = function (a, b){
        if (moment(a.validFrom, "YYYY-MM-DD") < moment(b.validFrom, "YYYY-MM-DD")) {
            return -1;
        }

        if (moment(a.validFrom, "YYYY-MM-DD") > moment(b.validFrom, "YYYY-MM-DD")) {
            return 1;
        }

        return 0;
    }

    const orderByName = function (a, b){
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }

    const orderByCategory = function (a, b){
        if (a.category < b.category) {
            return -1;
        }
        if (a.category > b.category) {
            return 1;
        }
        return 0;
    }

    const orderById = function (a, b){
        if (a.id < b.id) {
            return -1;
        }
        if (a.id > b.id) {
            return 1;
        }
        return 0;
    }

    const orderByLicence = function (a, b) {
        if (a.name?.split('-')[0] < b.name?.split('-')[0]) {
            return -1;
        }
        if (a.name?.split('-')[0] > b.name?.split('-')[0]) {
            return 1;
        }
        return 0;
    };

    const showLicenceHolderDetails = () => {
        let licenceHolderArr = [];
        let caption = 'Licence holder details';
        let licenceHolderCols = [
            {
                'label': 'Name',
                'property': 'name',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '40%'
            },
            {
                'label': user.fullname,
                'property': 'value',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '60%'
            },
            {
                'label': 'Id',
                'property': 'id',
                'visible': false,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '0%'
            }
        ];

        let dob = moment(user.birthdate, 'YYYY-MM-DD').format('DD MMM YYYY')

        let row1 = { 'name': 'ARN and licence number', 'value': user.casa_arn, 'id': '1' };
        let row2 = { 'name': 'Date of birth', 'value': dob, 'id': '2' };
        let row3 = { 'name': 'Nationality', 'value': user['nationality.casa_name'], 'id': '3' };

        licenceHolderArr.push(row1);
        licenceHolderArr.push(row2);
        licenceHolderArr.push(row3);

        return (
            <div>
                <SortedTable
                    data={licenceHolderArr}
                    cols={licenceHolderCols}
                    caption={caption}
                    sortby="id"
                    cellClasser={addBadge}
                    ignoreSortByColumn={true}
                />
            </div>
        );
    };

    const showCar5Notice = () => {
        
        return (
            <AUcallout title=''>
                <div>
                    If you log into your myCASA account on your mobile device, you can download a digital version of your flight crew licence to save to either your Apple Wallet or Google Wallet.
                    <br /><br />
                    Licence reprints are no longer available in myCASA. If you require a physical flight crew licence for operational requirements, like overseas operations, please <a href='http://casa.gov.au/about-us/contact-us'>contact CASA</a> to request the licence reprint form. There is an associated fee of $25 for a licence reprint.
                    <br /><br />
                    These licence details reflect the current CASA view of your licence. If you have recently had any new ratings or endorsements added, it may take sometime for these to be added to your licence in the CASA system.
                    <br /><br />
                    If there are any errors on this licence, <a href='http://casa.gov.au/about-us/contact-us'>contact CASA</a>.
                    <br /><br />
                    Please note that this is only a view of your flight crew licence. You may not exercise the privileges of your flight crew licence unless you are in possession of your digital or paper flight crew licence document
                </div>                
            </AUcallout>
        );
        
    };

    const showAsicVerify = () => {

        let linkAsicVerify = '/licence-view/asic-verification';
        return (
            <AUcallout title='Download your digital licence'>
                <span>
                    If you are a current ASIC holder you can now download a digital view of your flight crew licence on your iPhone. To do so you will need to verify your ASIC and consent to CASA using the photograph on your ASIC for your digital licence.
                </span>
                <br />
                <br />
                <div>
                    <Link
                        id="asicVerify"
                        className="au-btn au-btn--darker btn-Primary"
                        to={linkAsicVerify}>
                        Verify your ASIC and lodge photo
                    </Link>
                </div>
            </AUcallout>
        );
    };

    const showLicenceComponents = () => {
        //BR.02.001 Ratings in EAP with a category of “RPA Type” or “RPA Category” should not be shown on the FCL digital view.
        let licenceArr = [];
        let categoryOrdering = getCustomSortOrder(sortOrderCategory);
        components.components?.sort( function(a, b) {
            return (ignoreGliderFromSorting(a, b) || orderByLicence(a,b) || categoryOrdering[a.category?.trim().toUpperCase()] - categoryOrdering[b.category?.trim().toUpperCase()] || orderByValidFrom(b,a));
            });
        for (let i = 0; i < components.components.length; i++) {
            let item = {
                'licence': components.components[i].name,
                'category': components.components[i].category,
                'granteddate': moment(components.components[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                'status': components.components[i].componentStatus
            };
            licenceArr.push(item);
        }

        let caption = 'Licence and category rating';
        let licenceCols = [
            {
                'label': 'Licence',
                'property': 'licence',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '40%'
            },
            {
                'label': 'Category',
                'property': 'category',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            },
            {
                'label': 'Granted date',
                'property': 'granteddate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            },
            {
                'label': 'Status',
                'property': 'status',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            }
        ];

        if (licenceArr.length > 0) {
            return (
                <div>
                    <SortedTable
                        data={licenceArr}
                        cols={licenceCols}
                        caption={caption}
                        cellClasser={addBadge}
                        ignoreSortByColumn={true}
                    />
                </div>
            );
        }

    };

    const showAircraftRatings = () => {

        let categoryOrdering = getCustomSortOrder(sortOrderCategory);  

        let aircraftArr = [];

        ratings.classRating?.sort( function(a, b) {
            return (categoryOrdering[a.category?.trim().toUpperCase()] - categoryOrdering[b.category?.trim().toUpperCase()] || orderByValidFrom(b,a) || orderByName(a,b));
            });
        
        for (let i = 0; i < ratings.classRating?.length; i++) {
            let item = {
                'classratings': ratings.classRating[i].name,
                'category': ratings.classRating[i].category,
                'granteddate': moment(ratings.classRating[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                'validto': ratings.classRating[i].validUntil ? moment(ratings.classRating[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
            }
            aircraftArr.push(item);
        }

        let typeArr = [];
        ratings.typeRating?.sort( function(a, b) {
            return (categoryOrdering[a.category?.trim().toUpperCase()] - categoryOrdering[b.category?.trim().toUpperCase()] || orderByValidFrom(b,a) || orderByName(a,b));
            });
        for (let i = 0; i < ratings.typeRating?.length; i++) {
            let item = {
                'typeratings': ratings.typeRating[i].name,
                'category': ratings.typeRating[i].category,
                'granteddate': moment(ratings.typeRating[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                'validto': ratings.typeRating[i].validUntil ? moment(ratings.typeRating[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
            }
            typeArr.push(item);
        }

        let rplEndorsementArr = [];
        ratings.rplEndorsementRating?.sort( function(a, b) {
            return (categoryOrdering[a.category?.trim().toUpperCase()] - categoryOrdering[b.category?.trim().toUpperCase()] || orderByValidFrom(b,a));
            });
        for (let i = 0; i < ratings.rplEndorsementRating?.length; i++) {
            let item = {
                'design': ratings.rplEndorsementRating[i].name,
                'category': ratings.rplEndorsementRating[i].category,
                'granteddate': moment(ratings.rplEndorsementRating[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                'validto': ratings.rplEndorsementRating[i].validUntil ? moment(ratings.rplEndorsementRating[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
            }
            rplEndorsementArr.push(item);
        }

        let designArr = [];
        ratings.designRating?.sort( function(a, b) {
            return (categoryOrdering[a.category?.trim().toUpperCase()] - categoryOrdering[b.category?.trim().toUpperCase()] || orderByValidFrom(b,a));
            });
        for (let i = 0; i < ratings.designRating?.length; i++) {
            let item = {
                'design': ratings.designRating[i].name,
                'category': ratings.designRating[i].category,
                'granteddate': moment(ratings.designRating[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                'validto': ratings.designRating[i].validUntil ? moment(ratings.designRating[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
            }
            designArr.push(item);
        }



        let aircraftCols = [
            {
                'label': 'Class ratings',
                'property': 'classratings',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '40%'
            },
            {
                'label': 'Category',
                'property': 'category',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            },
            {
                'label': 'Granted date',
                'property': 'granteddate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            },
            {
                'label': 'Valid to',
                'property': 'validto',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            }
        ];

        let typeCols = [
            {
                'label': 'Type ratings',
                'property': 'typeratings',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '40%'
            },
            {
                'label': 'Category',
                'property': 'category',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            },,
            {
                'label': 'Granted date',
                'property': 'granteddate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            },
            {
                'label': 'Valid to',
                'property': 'validto',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            }
        ];
       
        let designCols = [
            {
                'label': 'Design feature endorsements',
                'property': 'design',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '40%'
            },
            {
                'label': 'Category',
                'property': 'category',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            },,
            {
                'label': 'Granted date',
                'property': 'granteddate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            },
            {
                'label': 'Valid to',
                'property': 'validto',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            }
        ];

        let rplEndorsementCols = [
            {
                'label': 'Recreational pilot licence endorsements',
                'property': 'design',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '60%'
            },
            {
                'label': 'Granted date',
                'property': 'granteddate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            },
            {
                'label': 'Valid to',
                'property': 'validto',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            }
        ];

        let caption = 'Aircraft ratings and endorsements';

        return (
            <div>
                {aircraftArr.length > 0 &&
                    <div>
                        <SortedTable
                            data={aircraftArr}
                            cols={aircraftCols}
                            caption={caption}
                            cellClasser={pastDate}
                            ignoreSortByColumn={true}
                        />
                    </div>
                }

                {rplEndorsementArr.length > 0 &&
                    <div>
                        <SortedTable
                            data={rplEndorsementArr}
                            cols={rplEndorsementCols}
                            caption={aircraftArr.length == 0 ? caption : null}
                            ignoreSortByColumn={true}
                        />
                    </div>
                
                }
                
                {designArr.length > 0 &&
                    <div>
                        <SortedTable
                            data={designArr}
                            cols={designCols}
                            caption={aircraftArr.length == 0 && rplEndorsementArr.length == 0 ? caption : null}
                            ignoreSortByColumn={true}
                        />
                    </div>
                
                }

                {typeArr.length > 0 &&
                    <div>
                        <SortedTable
                            data={typeArr}
                            cols={typeCols}
                            caption={aircraftArr.length == 0 && rplEndorsementArr.length == 0  && designArr.length == 0 ? caption : null}
                            ignoreSortByColumn={true}
                        />
                    </div>
                }
            </div>
        );               
    }

    const showOperationalRatings = () => {

        const getPatentAndChildByParentName = function (components, parentName){
            let parentChildComponents = [];
            let childComponents = components?.filter((x) => x.name?.trim().toUpperCase() !== parentName?.toUpperCase());        
    
            for (let i = 0; i < components?.length; i++) {
                if(components[i].name?.trim().toUpperCase() === parentName?.toUpperCase()){navigateLicenceRePrint
                    let item = {
                        'instrumentRating': components[i].name,
                        'endorsement': '',
                        'category': '',
                        'granteddate': moment(components[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                        'validto': components[i].validUntil ? moment(components[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
                    };
                    parentChildComponents.push(item);
                    break;
                }
            }

            if(childComponents?.length > 1){
                childComponents.sort( function(a, b) {
                    return (orderByCategory(a,b) || orderByValidFrom(b,a) || orderByName(a,b));
                    });        
            }

            childComponents = [
                ...childComponents.filter(x => x.printName !== 'TR'),
                ...childComponents.filter(x => x.printName === 'TR')
              ];
    
            for (let i = 0; i < childComponents?.length; i++) {

                let item = {};
                if(childComponents[i].ratings?.length > 0){
                    childComponents[i].ratings.sort( function(a, b) {
                        return (orderByCategory(a,b) || orderByValidFrom(b,a) || orderByName(a,b));
                    });  
                    for(let j = 0; j < childComponents[i].ratings.length; j++){
                        item = {
                            'instrumentRating': '',
                            'endorsement': childComponents[i].name + ' ' + childComponents[i].ratings[j].printName,
                            'category': childComponents[i].ratings[j].category,
                            'granteddate': moment(childComponents[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                            'validto': childComponents[i].validUntil ? moment(childComponents[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
                        };
                        parentChildComponents.push(item);
                    }
                }
                else{
                    item = {
                        'instrumentRating': '',
                        'endorsement': childComponents[i].name,
                        'category': childComponents[i].category,
                        'granteddate': moment(childComponents[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                        'validto': childComponents[i].validUntil ? moment(childComponents[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
                    };
                    parentChildComponents.push(item);
                }          
                
            }  
            return parentChildComponents;
        }
        const formatRatingAsPatentAndChild = function (ratings, sort = true) {
            let parentChildRatings = [];
            const parentComponents = ratings?.flatMap(x => x.components).sort(orderById);
            const map = new Map(parentComponents.map(c => [c.componentId, c]));
            const uniqueComponents = [...map.values()];
            for(let j = 0; j < uniqueComponents.length; j++)
            {
                parentChildRatings.push(
                    {
                        'instrumentRating': uniqueComponents[j].name,
                        'endorsement': '',
                        'category': '',
                        'granteddate': moment(uniqueComponents[j].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                        'validto': uniqueComponents[j].validUntil ? moment(uniqueComponents[j].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
                    }
                );
                let componentRatings = [];
                if(ratings?.length > 0){
                    componentRatings = ratings.filter((rating) => rating.components.filter((component) => component.name === uniqueComponents[j].name).length > 0);
                }

                if(sort){
                    let categoryOrdering = getCustomSortOrder(sortOrderCategory);
                    componentRatings.sort( function(a, b) {
                    return (categoryOrdering[a.category?.trim().toUpperCase()] - categoryOrdering[b.category?.trim().toUpperCase()] || orderByValidFrom(b,a) || orderByName(a,b));
                    });
                }

                for (let i = 0; i < componentRatings.length; i++) {
                    let item = {
                        'instrumentRating': '',
                        'endorsement': componentRatings[i].name,
                        'category': componentRatings[i].category,
                        'granteddate': moment(componentRatings[i].validFrom, 'YYYY-MM-DD').format('DD MMM YYYY'),
                        'validto': componentRatings[i].validUntil ? moment(componentRatings[i].validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
                    }
                    parentChildRatings.push(item);
                }
            }
            return parentChildRatings;
        };

        let operationalRatingsCols = [
            {
                'label': 'Operational ratings',
                'property': 'instrumentRating',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            },
            {
                'label': 'Endorsements',
                'property': 'endorsement',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            },
            {
                'label': 'Category',
                'property': 'category',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '20%'
            },
            {
                'label': 'Granted date',
                'property': 'granteddate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            },
            {
                'label': 'Valid to',
                'property': 'validto',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            }
        ];
        
        let lowLevelArr = formatRatingAsPatentAndChild(operationalRatings.lowLevel);

        let aerialAppArr = formatRatingAsPatentAndChild(operationalRatings.aerialApp);    
        
        let instrumentArr = formatRatingAsPatentAndChild(operationalRatings.instrument);

        let nightvfrArr = formatRatingAsPatentAndChild(operationalRatings.nightVFR);

        let nightvisionimagingArr = formatRatingAsPatentAndChild(operationalRatings.nightVision, false);   

        let privateinstrumentArr = formatRatingAsPatentAndChild(operationalRatings.privateInstrument, false); 

        let flightinstructorArr = getPatentAndChildByParentName(operationalRatings.flightInstructor, FCL_CONSTANTS.FLIGHT_INSTRUCTOR_RATING);

        let flightexaminerArr = getPatentAndChildByParentName(operationalRatings.flightExaminer, FCL_CONSTANTS.FLIGHT_EXAMINER_RATING);
    
        let flightactivityArr = formatRatingAsPatentAndChild(operationalRatings.flightActivity, false);    

        let operationalActivityAndEndorsements = [...instrumentArr, ...nightvfrArr, ...privateinstrumentArr, ...flightinstructorArr, ...aerialAppArr, ...nightvisionimagingArr, ...flightexaminerArr, ...lowLevelArr, ...flightactivityArr];
        
        operationalActivityAndEndorsements = operationalActivityAndEndorsements.filter((x) => !x.endorsement?.toUpperCase()?.includes('EXEMPTION'));

        const styleCellInstrumentRating = (row, col) => {
            if (col.property === "instrumentRating") {
                var cellStyle = {
                    fontWeight: 'bold'
                };
                return cellStyle;
            }
        }
        
        let caption = 'Operational ratings and endorsements';
        return (
            <div>
                {operationalActivityAndEndorsements.length > 0 &&
                    <div>
                        <SortedTable
                            data={operationalActivityAndEndorsements}
                            cols={operationalRatingsCols}
                            caption={caption}
                            ignoreSortByColumn={true}
                            cellStyler={styleCellInstrumentRating}
                        />
                    </div>
                }
            </div>
        );

    };

    const showTheoryExaminations = () => {
        let proficiencyArr = [];
        for (let i = 0; i < theoryExaminations?.length; i++) {
            let item = {
                'proficiencyrating': theoryExaminations[i].type === 'Language Proficiency Check' ? 'AELP Level ' + theoryExaminations[i].result.actualLevel : 'GELP',
                'granteddate': moment(theoryExaminations[i].result.issuedDate, 'YYYY-MM-DD').format('DD MMM YYYY'),
                'validto': theoryExaminations[i].result.validUntil ? moment(theoryExaminations[i].result.validUntil, 'YYYY-MM-DD').format('DD MMM YYYY') : 'N/A'
            }
            proficiencyArr.push(item);
        }
        
        let caption = 'English language proficiency';

        let proficiencyCols = [
            {
                'label': 'Proficiency rating',
                'property': 'proficiencyrating',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'string',
                'width': '60%'
            },
            {
                'label': 'Granted date',
                'property': 'granteddate',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            },
            {
                'label': 'Valid to',
                'property': 'validto',
                'visible': true,
                'command': null,
                'commandLink': null,
                'type': 'date',
                'width': '20%'
            }
        ];

        if (proficiencyArr.length > 0) {
            return (
                <div>
                    <SortedTable
                        data={proficiencyArr}
                        cols={proficiencyCols}
                        caption={caption}
                        sortby='proficiencyrating'
                        ignoreSortByColumn={true}
                    />
                </div>
            );
        
        }
    }

    const displayDigitalLicenceAppleBtn = () => {
        return (
            <AUbutton as='secondary' onClick={onDigLicAppleClick}>
                Download digital licence for Apple Wallet
            </AUbutton>
        );
    };

    const displayDigitalLicenceGoogleBtn = () => {
        return (
            <AUbutton as='secondary' onClick={onDigLicGoogleClick}>
                Download digital licence for Google Wallet
            </AUbutton>
        );
    };

    if (!pilotLicenceDetailsLoaded.loaded) {
        return (
            <CASASpinner message='Loading. Please wait...' />
        );
    }
    else {
        return (
            <Fragment>
                <div style={{ minHeight: '800px' }}>
                    <MetaTags title='Flight Crew Licence Details'></MetaTags>

                    <Heading
                        text='Flight Crew Licence Details'
                        breadcrumbs={items}
                        showcrumbs={showItems}
                        showback={false} />

                    {/*link back*/}
                    <AUformGroup>
                        <AUdirectionLink link='/dashind' text='Back' direction='left' style={{ marginTop: '10px' }} />
                    </AUformGroup>

                    <br />

                    <CasaModal
                        heading='Digital flight crew licence'
                        toggle={toggleModalGoogle}
                        active={modalActiveGoogle}
                        scrollable={true}
                        action={getGoogleLicence}
                        image='/forms/images/enAU_add_to_google_wallet_wallet-button.svg'
                        imageText='Save to Google Wallet'
                        cancelLabel='Close'>
                        <Fragment >
                            <div dangerouslySetInnerHTML={setInnerHTML(googleSnippet)} />
                        </Fragment>
                    </CasaModal>

                    <CasaModal
                        heading='Digital flight crew licence'
                        toggle={toggleModalApple}
                        active={modalActiveApple}
                        scrollable={true}
                        action={getAppleLicence}
                        image='/forms/images/Add_to_Apple_Wallet_rgb_US-UK.svg'
                        imageText='Add to Apple Wallet'
                        cancelLabel='Close'>
                        <Fragment >
                            <div dangerouslySetInnerHTML={setInnerHTML(appleSnippet)} />
                        </Fragment>
                    </CasaModal>

                    {showSpinner()}

                    {digitalFCLFeatureAvailable && iphone && hasPicture && !ratings.notConverted ? displayDigitalLicenceAppleBtn() : null}
                    {digitalFCLFeatureAvailable && android && hasPicture && !ratings.notConverted ? displayDigitalLicenceGoogleBtn() : null}
                    
                    {!hasPicture && digitalFCLFeatureAvailable && (iphone || android) ? showAsicVerify() : null}
                   
                    {/*car 5 notice*/}
                    {showCar5Notice()}

                    {/*licence holder details*/}
                    {showLicenceHolderDetails()}

                    {/*licence components*/}
                    {showLicenceComponents()}

                    {/*aircraft ratings*/}
                    {showAircraftRatings()}

                    {/*operational ratings*/}
                    {showOperationalRatings()}

                    {/*theoryexam*/}
                    {showTheoryExaminations()}

                    {/*link back*/}
                    <AUformGroup>
                        <AUdirectionLink link='/dashind' text='Return to myCASA' direction='left' style={{ marginTop: '50px' }} />
                    </AUformGroup>
                </div>
            </Fragment>
        );
    }
};
